module.exports = __webpack_public_path__ + "img/four3Orange.36912cd7.jpg";